// const ignoreline = 'ignoreline';

// console.log(ignoreline);

// add src with full uri to imgs
for (const elm of document.querySelectorAll('[data-static^="ignoreline"]')) {
    // console.log(elm);

    for (const img of elm.querySelectorAll('img[data-src]')) {
        img.src = assetUri['ignoreline'] + '/' + img.dataset.src;
        // console.log(assetUri['ignoreline'] + '/' + img.dataset.src);
        img.removeAttribute('data-src');
    }
}

// define interval if given
if (interval['ignoreline'] === false) {
    interval['ignoreline'] = 10000;
}

// set status if given
if (data.status) {
    statusUri['ignoreline'] = url + '/' + data.status;
}

statusUri['ignoreline'] += '/status.json';

// start interval
console.log('yootalkInterval');
const yootalkInterval = setInterval(() => {
    // console.log('yootalk1');
    // console.log(ignoreline);
    getStatus();
}, interval['ignoreline']);

const getStatus = () => {
    fetch(statusUri['ignoreline'], {
        headers: { "Content-Type": "application/json; charset=utf-8" },
        method: 'GET',
    })
    .then(response => {
        // console.log(response);

        if (response.ok) {
            // console.log('response ok');
            return Promise.resolve(response);
        } else {
            // console.log('response failed');
            return Promise.reject(new Error('Failed to load'));
        }
    })
    .then(response => response.json())
    .then(data => {
        // console.log(data);

            // document.querySelector('.ignoreline-banner figcaption').removeAttribute('class');
            // document.querySelector('.ignoreline-banner figcaption').classList.add('block-' + data.status);
            // console.log(elm.querySelector('figcaption'));
            // elm.querySelector('figcaption').classList.add('test1');

        for (const elm of document.querySelectorAll('[class^="ignoreline-"]')) {

            for (const img of elm.querySelectorAll('img.img-fluid')) {
                img.classList.remove('visible');

                if (img.classList.contains(data.status)) {
                    img.classList.add('visible');
                }
            }

            // for (const span of elm.querySelectorAll('span[class]')) {
            //     span.classList.remove('visible');

            //     if (span.classList.contains(data.status)) {
            //         span.classList.add('visible');
            //     }
            // }
        }

    })
    .catch(function(error) {
    });
}

// init banner
getStatus();
